export function getInputModelConstraints(modelSchema) {
  const inputImageSchema = modelSchema?.input_schema?.properties?.input_image?.format
  const { allowedTypes = [], maxFileSize = 0 } = inputImageSchema || {}

  return { allowedTypes, maxFileSize }
}
